<template>
  <div class="relative">
    <div class="flex items-center bg-white/15 border border-white/20 rounded px-2 py-1 gap-2">
      <svg class="w-3 h-3 text-slate-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z" />
      </svg>
      <input
        ref="inputEl"
        v-model="localQuery"
        type="text"
        placeholder="Search documentation..."
        class="bg-transparent text-white text-xs placeholder-slate-500 outline-none flex-1 min-w-0"
        @input="onInput"
        @keydown.escape="clear"
        @keydown.down.prevent="moveSelection(1)"
        @keydown.up.prevent="moveSelection(-1)"
        @keydown.enter.prevent="confirmSelection"
      />
      <button v-if="localQuery" @click="clear" class="text-slate-400 hover:text-white flex-shrink-0 leading-none">&#10005;</button>
    </div>

    <ul v-if="results.length > 0" class="absolute z-50 top-full left-0 right-0 mt-1 bg-ui-bg border border-white/20 rounded shadow-lg max-h-48 overflow-y-auto">
      <li
        v-for="(result, i) in results"
        :key="result.id"
        :class="['px-3 py-1.5 cursor-pointer text-xs', i === selectedIndex ? 'bg-ui-active text-white' : 'text-slate-200 hover:bg-white/10']"
        @mousedown.prevent="select(result)"
        @mouseover="selectedIndex = i"
      >
        <span class="font-medium">{{ result.title }}</span>
        <span v-if="result.category" class="ml-2 text-slate-400">{{ result.category }}</span>
        <p v-if="result.summary" class="text-slate-400 truncate mt-0.5">{{ result.summary }}</p>
      </li>
    </ul>

    <div v-else-if="localQuery && store.indexLoaded && !results.length" class="absolute z-50 top-full left-0 right-0 mt-1 bg-ui-bg border border-white/20 rounded px-3 py-2 text-xs text-slate-400">
      No results for "{{ localQuery }}"
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useDocumentationStore } from '../../stores/documentationStore.js'

const emit = defineEmits(['select'])
const store = useDocumentationStore()

const localQuery = ref('')
const selectedIndex = ref(-1)
const results = ref([])

function onInput() {
  selectedIndex.value = -1
  store.search(localQuery.value)
  results.value = store.searchResults
}

function clear() {
  localQuery.value = ''
  store.clearSearch()
  results.value = []
}

function moveSelection(dir) {
  if (!results.value.length) return
  selectedIndex.value = (selectedIndex.value + dir + results.value.length) % results.value.length
}

function confirmSelection() {
  const item = results.value[selectedIndex.value] ?? results.value[0]
  if (item) select(item)
}

function select(result) {
  emit('select', result.id)
  clear()
}

watch(() => store.searchResults, (val) => { results.value = val })
</script>
